import Vue from 'vue';
import VueRouter from 'vue-router';
import { isUserLoggedIn, getHomeRouteForLoggedInUser } from '@/auth/utils';
import { layout } from 'echarts/lib/layout/barGrid';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'chart',
      component: () => import('@/views/chart/index.vue'),
      meta: {
        roles: ['admin', 'owner'],
        auth: true,
        pageTitle: 'Homepage',
        breadcrumb: [
          {
            text: 'Homepage',
            active: true,
          },
        ],
      },
    },
    {
      path: '/wip',
      name: 'wip',
      component: () => import('@/views/wip/index.vue'),
      meta: {
        roles: ['admin', 'owner'],
        auth: true,
        pageTitle: 'WIP',
        breadcrumb: [
          {
            text: 'WIP',
            active: true,
          },
        ],
      },
    },
    {
      path: '/editorial',
      name: 'editorial',
      component: () => import('@/views/editorial/index.vue'),
      meta: {
        roles: ['admin', 'owner'],
        auth: true,
        pageTitle: 'Editorial',
        breadcrumb: [
          {
            text: 'Editorial',
            active: true,
          },
        ],
      },
    },
    {
      path: '/stat-website',
      name: 'stat_website',
      component: () => import('@/views/stat_website/index.vue'),
      meta: {
        roles: ['admin', 'owner'],
        auth: true,
        pageTitle: 'Stat Website',
        breadcrumb: [
          {
            text: 'Stat Website',
            active: true,
          },
        ],
      },
    },
    {
      path: '/partner',
      name: 'partner',
      component: () => import('@/views/partner/index.vue'),
      meta: {
        roles: ['admin'],
        auth: true,
        pageTitle: 'Partner',
        breadcrumb: [
          {
            text: 'Partner',
            active: true,
          },
        ],
      },
    },
    {
      path: '/partner/create',
      name: 'partner.create',
      component: () => import('@/views/partner/detail.vue'),
      meta: {
        roles: ['admin'],
        auth: true,
        pageTitle: 'Create Partner',
        breadcrumb: [
          {
            text: 'Partner',
            active: true,
          },
          {
            text: 'Create Partner',
            active: true,
          },
        ],
        navActiveLink: 'partner',
      },
    },
    {
      path: '/partner/update/:id',
      name: 'partner.update',
      component: () => import('@/views/partner/detail.vue'),
      meta: {
        roles: ['admin'],
        auth: true,
        pageTitle: 'Update Partner',
        breadcrumb: [
          {
            text: 'Partner',
            active: true,
          },
          {
            text: 'Update Partner',
            active: true,
          },
        ],
        navActiveLink: 'partner',
      },
    },
    {
      path: '/post-category',
      name: 'post_category',
      component: () => import('@/views/Category.vue'),
      meta: {
        roles: ['admin', 'owner'],
        auth: true,
        pageTitle: 'Post Category',
        breadcrumb: [
          {
            text: 'Post Category',
            active: true,
          },
        ],
      },
    },
    {
      path: '/user',
      name: 'user',
      component: () => import('@/views/User.vue'),
      meta: {
        roles: ['admin', 'owner'],
        auth: true,
        pageTitle: 'User',
        breadcrumb: [
          {
            text: 'User',
            active: true,
          },
        ],
      },
    },
    {
      path: '/posts',
      name: 'posts',
      component: () => import('@/views/posts/index.vue'),
      meta: {
        roles: ['admin', 'owner', 'editor', 'contributor'],
        auth: true,
        pageTitle: 'Posts',
        breadcrumb: [
          {
            text: 'Posts',
            active: true,
          },
        ],
      },
    },
    {
      path: '/posts/create',
      name: 'posts.create',
      component: () => import('@/views/posts/detail.vue'),
      meta: {
        roles: ['admin', 'owner', 'editor', 'contributor'],
        auth: true,
        pageTitle: 'Posts Create',
        breadcrumb: [
          {
            text: 'Posts',
            active: true,
          },
          {
            text: 'Posts Create',
            active: true,
          },
        ],
        navActiveLink: 'posts',
      },
    },
    {
      path: '/posts/detail/:id',
      name: 'posts.detail',
      component: () => import('@/views/posts/detail.vue'),
      meta: {
        roles: ['admin', 'owner', 'editor', 'contributor'],
        auth: true,
        pageTitle: 'Posts Detail',
        breadcrumb: [
          {
            text: 'Posts',
            active: true,
          },
          {
            text: 'Posts Detail',
            active: true,
          },
        ],
        navActiveLink: 'posts',
      },
    },
    {
      path: '/posts/generate-ai',
      name: 'posts.ai',
      component: () => import('@/views/posts/generate_articles.vue'),
      meta: {
        layout: 'full',
        roles: ['admin', 'owner', 'editor', 'contributor'],
        auth: true,
      },
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/views/Settings.vue'),
      meta: {
        roles: ['owner'],
        auth: true,
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            active: true,
          },
        ],
      },
    },
    {
      path: '/navbar',
      name: 'navbar',
      component: () => import('@/views/Navbar.vue'),
      meta: {
        roles: ['admin', 'owner'],
        auth: true,
        pageTitle: 'Navbar',
        breadcrumb: [
          {
            text: 'Navbar',
            active: true,
          },
        ],
      },
    },
    {
      path: '/navbar-mapping',
      name: 'navbar.mapping',
      component: () => import('@/views/NavbarMapping.vue'),
      meta: {
        roles: ['admin', 'owner'],
        auth: true,
        pageTitle: 'Navbar Mapping',
        breadcrumb: [
          {
            text: 'Navbar',
            to: 'navbar',
          },
          {
            text: 'Navbar Mapping',
            active: true,
          },
        ],
        navActiveLink: 'navbar',
      },
    },
    {
      path: '/pages',
      name: 'pages',
      component: () => import('@/views/page/index.vue'),
      meta: {
        roles: ['admin', 'owner'],
        auth: true,
        pageTitle: 'Page',
        breadcrumb: [
          {
            text: 'Page',
            active: true,
          },
        ],
      },
    },
    {
      path: '/pages/create',
      name: 'pages.create',
      component: () => import('@/views/page/detail.vue'),
      meta: {
        roles: ['admin', 'owner'],
        auth: true,
        pageTitle: 'Page',
        breadcrumb: [
          {
            text: 'Page',
            active: true,
          },
        ],
        navActiveLink: 'pages',
      },
    },
    {
      path: '/pages/update/:id',
      name: 'pages.update',
      component: () => import('@/views/page/detail.vue'),
      meta: {
        roles: ['admin', 'owner'],
        auth: true,
        pageTitle: 'Page',
        breadcrumb: [
          {
            text: 'Page',
            active: true,
          },
        ],
        navActiveLink: 'pages',
      },
    },
    {
      path: '/footer',
      name: 'footer',
      component: () => import('@/views/footer/index.vue'),
      meta: {
        roles: ['admin', 'owner'],
        auth: true,
        pageTitle: 'Footer',
        breadcrumb: [
          {
            text: 'Footer',
            active: true,
          },
        ],
      },
    },
    {
      path: '/footer/create',
      name: 'footer.create',
      component: () => import('@/views/footer/detail.vue'),
      meta: {
        roles: ['admin', 'owner'],
        auth: true,
        pageTitle: 'Footer Create',
        breadcrumb: [
          {
            text: 'Footer',
          },
          {
            text: 'Footer Create',
            active: true,
          },
        ],
        navActiveLink: 'footer',
      },
    },
    {
      path: '/footer/update/:id',
      name: 'footer.update',
      component: () => import('@/views/footer/detail.vue'),
      meta: {
        roles: ['admin', 'owner'],
        auth: true,
        pageTitle: 'Footer Update',
        breadcrumb: [
          {
            text: 'Footer',
            active: true,
          },
          {
            text: 'Footer Update',
            active: true,
          },
        ],
        navActiveLink: 'footer',
      },
    },
    {
      path: '/banner-management/',
      name: 'banner',
      component: () => import('@/views/banner/index.vue'),
      meta: {
        roles: ['admin', 'owner'],
        auth: true,
        pageTitle: 'Banner Management',
        breadcrumb: [
          {
            text: 'Banner Management',
            active: true,
          },
        ],
      },
    },
    {
      path: '/banner-management/create',
      name: 'banner.create',
      component: () => import('@/views/banner/detail.vue'),
      meta: {
        roles: ['admin', 'owner'],
        auth: true,
        pageTitle: 'Banner Management Create',
        breadcrumb: [
          {
            text: 'Banner Management',
          },
          {
            text: 'Banner Management Create',
            active: true,
          },
        ],
        navActiveLink: 'banner',
      },
    },
    {
      path: '/banner-management/update/:id',
      name: 'banner.update',
      component: () => import('@/views/banner/detail.vue'),
      meta: {
        roles: ['admin', 'owner'],
        auth: true,
        pageTitle: 'Banner Management Update',
        breadcrumb: [
          {
            text: 'Banner Management',
            active: true,
          },
          {
            text: 'Banner Management Update',
            active: true,
          },
        ],
        navActiveLink: 'banner',
      },
    },
    {
      path: '/category-mapping',
      name: 'list_category.mapping',
      component: () =>
        import('@/views/category_groups/ListCategoryMapping.vue'),
      meta: {
        roles: ['admin', 'owner'],
        auth: true,
        pageTitle: 'List Category Mapping',
        breadcrumb: [
          {
            text: 'List Category Mapping',
            active: true,
          },
        ],
        // navActiveLink: 'category',
      },
    },
    {
      path: '/category-mapping',
      name: 'update_category.mapping',
      component: () => import('@/views/category_groups/CategoryMapping.vue'),
      meta: {
        roles: ['admin', 'owner'],
        auth: true,
        pageTitle: 'Update Category Mapping',
        breadcrumb: [
          {
            text: 'List Category Mapping',
            to: 'list_category.mapping',
          },
          {
            text: 'Update Category Mapping',
            active: true,
          },
        ],
        navActiveLink: 'list_category.mapping',
      },
    },
    {
      path: '/embed-media/',
      name: 'embed',
      component: () => import('@/views/embed/index.vue'),
      meta: {
        roles: ['admin', 'owner'],
        auth: true,
        pageTitle: 'Embed Media',
        breadcrumb: [
          {
            text: 'Embed Media',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
});

/**
 * Asynchronous function to fetch user data.
 * Checks if the user is logged in, then makes a GET request to 'admin/users/me' endpoint using Vue's HTTP client.
 * Returns the user data if successful, otherwise logs the error and returns null.
 *
 * @returns {Object|null} The user data if successful, otherwise null.
 */
const getUser = async () => {
  try {
    if (!isUserLoggedIn()) return null;

    const result = await Vue.prototype.$http.get('admin/users/me');
    return result.data.data || null;
  } catch (error) {
    console.error('Error fetching user data:', error);
    return null; // Return null in case of an error
  }
};

router.beforeEach(async (to, from, next) => {
  const isLoggedIn = isUserLoggedIn();
  const userData = await getUser();
  // Redirect if not authenticated
  if (to.matched.some((record) => record.meta.auth)) {
    const allowedRoles = to.meta.roles || [];
    if (userData) {
      if (allowedRoles.includes(userData.role)) {
        next();
      } else {
        next({ name: 'login' });
      }
    } else {
      next({ name: 'login' });
    }
  } else {
    next();
  }

  // Redirect if authenticated
  if (to.matched.some((record) => record.meta.guest) && isLoggedIn) {
    next(getHomeRouteForLoggedInUser());
  }
});

export default router;
